export default __webpack_public_path__ + "c9004912bb890c8a961f58316555c745.svg";